/**
 * Neutral colors for Material-UI theme
 *
 * @public
 */
export const neutral = {
  100: '#F3F4F6',
  200: '#E5E7EB',
  300: '#D2D6DB',
  400: '#9DA4AE',
  50: '#F8F9FA',
  500: '#6C737F',
  600: '#4D5761',
  700: '#2F3746',
  800: '#1C2536',
  900: '#111927',
};

/**
 * Primary colors for Material-UI theme
 *
 * @public
 */
export const primary = {
  contrastText: '#FFFFFF',
  dark: '#109962',
  darkest: '#076753',
  darkestBg: '#022723',
  light: '#6EE792',
  lightest: '#CFFBD3',
  main: '#17B264',
};

/**
 * Secondary colors for Material-UI theme
 *
 * @public
 */
export const secondary = {
  contrastText: '#FFFFFF',
  dark: '#2F3746',
  darkest: '#111927',
  light: '#EAEFF5',
  lightest: '#F8FAFC',
  main: '#6C737F',
};

/**
 * Error colors for Material-UI theme
 *
 * @public
 */
export const error = {
  contrastText: '#FFFFFF',
  dark: '#B42318',
  darkest: '#7A271A',
  light: '#FEE4E2',
  lightest: '#FEF3F2',
  main: '#F04438',
};

/**
 * Warning colors for Material-UI theme
 *
 * @public
 */
export const warning = {
  contrastText: '#FFFFFF',
  dark: '#B54708',
  darkest: '#7A2E0E',
  light: '#FEF0C7',
  lightest: '#FFFAEB',
  main: '#F79009',
};

/**
 * Info colors for Material-UI theme
 *
 * @public
 */
export const info = {
  contrastText: '#FFFFFF',
  dark: '#0E7090',
  darkest: '#164C63',
  light: '#CFF9FE',
  lightest: '#ECFDFF',
  main: '#06AED4',
};

/**
 * Success colors for Material-UI theme
 *
 * @public
 */
export const success = {
  contrastText: '#FFFFFF',
  dark: '#107569',
  darkest: '#134E48',
  light: '#CCFBEF',
  lightest: '#F0FDF9',
  main: '#15B79E',
};

/**
 * Grey colors for Material-UI theme
 *
 * @public
 */
export const grey = {
  300: '#E0E0E0',
};
